var _effectorFileName = "/builds/gmini/front-common/src/components/NumCycle/NumCycleContainer.tsx";
import "core-js/modules/es.function.name.js";
import { useHover, useWithDelay } from '@gmini/utils';
import React from 'react';
import { NumCircle } from "../Marker";
import { NumCircleWrap } from "./NumCycle.styled";
import { jsx as _jsx } from "react/jsx-runtime";
export var NumCycleContainer = function NumCycleContainer(_ref) {
  var dependencyData = _ref.dependencyData,
      onSearchSource = _ref.onSearchSource;
  var source = dependencyData.source,
      name = dependencyData.name,
      displayNumber = dependencyData.displayNumber;

  var _useWithDelay = useWithDelay(useHover(), {
    enterDelay: 400,
    leaveDelay: 200
  }),
      hover = _useWithDelay.hover,
      onMouseLeave = _useWithDelay.onMouseLeave,
      onMouseOver = _useWithDelay.onMouseOver;

  React.useEffect(function () {
    if (hover && onSearchSource) {
      onSearchSource(source);
      return function () {
        onSearchSource(null);
      };
    }
  }, [hover, onSearchSource, source]);
  return /*#__PURE__*/_jsx(NumCircleWrap, {
    children: /*#__PURE__*/_jsx(NumCircle, {
      onMouseLeave: onMouseLeave,
      onMouseOver: onMouseOver,
      tooltipTitle: name,
      children: displayNumber
    })
  });
};